import React from "react";
import { Routes, Route } from "react-router-dom";
import About from "../pages/About";
import Terms from "../pages/Terms";
import Contact from "../pages/Contact";
import GetAuth from "../components/GetAuth";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/Home";

const NotUser = () => {
  return (
   <div className="not-user">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/login" element={<GetAuth />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
   </div>
  );
};

export default NotUser;
